<template>
  <div>
    <form-title title="Informação *" />
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          :value="editItem.nome"
          :rules="[rules.required]"
          label="Título *"
          @input="onEditChange({nome: $event})"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-select
          :items="segmentos"
          label="Área *"
          item-text="segmento"
          item-value="id"
          :rules="[rules.required]"
          :value="editItem.segmento && editItem.segmento.idSegmento"
          @input="onEditChange({
                                  segmento: {
                                    ...editItem.segmento,
                                    idSegmento: $event,
                                  }
                                })"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          :value="editItem.sinopse"
          label="Tema"
          @input="onEditChange({sinopse: $event})"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-select
          :items="familiaPublicacoes"
          label="Tipo da publicação *"
          item-text="descricao"
          item-value="id"
          multiple
          :rules="[rules.required]"
          :value="familias"
          @input="onEditFamiliasChange($event)"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <form-title title="Data do documento *" />
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
            <v-text-field
              v-mask="['##/##/####']"
              label="Data inicial *"
              placeholder="DD/MM/AAAA"
              :rules="[rules.required, rules.date]"
              :value="editItem.dtImagem"
              type="tel"
              dense
              clearable
              @input="onEditChange({dtImagem: $event})"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            <v-text-field
              v-mask="['##/##/####']"
              label="Data final *"
              placeholder="DD/MM/AAAA"
              :rules="[rules.required, rules.date]"
              :value="editItem.dtLimite"
              type="tel"
              dense
              clearable
              @input="onEditChange({dtLimite: $event})"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <form-title title="Idioma" />
        <v-select
          :items="idiomas"
          placeholder="Selecione o idioma"
          item-text="idioma"
          clearable
          item-value="id"
          :value="editItem.idioma && editItem.idioma.idIdiomaPub"
          @input="onEditChange({
                                  idioma: {
                                    ...editItem.idioma,
                                    idIdiomaPub: $event,
                                  }
                                })"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <form-title title="Autor" />
        <v-text-field
          :value="editItem.fonte"
          placeholder="Digite o autor"
          @input="onEditChange({fonte: $event})"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import formRules from '@/mixins/form-rules';
import formTitle from '@/components/form-title.vue';

export default {
  mixins: [formRules],
  components: {
    formTitle,
  },
  data() {
    return {
      multiple: [],
    };
  },
  props: {
    editItem: {
      type: Object,
      default: () => {},
    },
    onEditChange: {
      type: Function,
      default: () => false,
    },
    onEditFamiliasChange: {
      type: Function,
      default: () => false,
    },
    idiomas: {
      type: Array,
      default: () => [],
    },
    segmentos: {
      type: Array,
      default: () => [],
    },
    familiaPublicacoes: {
      type: Array,
      default: () => [],
    },
    familias: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
